export const CURRENCIES = ["usd", "eur"] as const;
export type Currency = (typeof CURRENCIES)[number];
